import { HttpParams } from '@angular/common/http';

import { Pessoa } from '../../pessoa';
import { Representante } from '../../pessoa/representante';

/** Representa o Filter para pesquisar os Item */
export class ItemFilterSearch {
    filterPsq: string;
    codigoIntegracaoErp: string;
    situacao: number;
    idPessoa: number;
    pessoa: Pessoa;
    idItemGrupo: number;
    idItemSubgrupo: number;
    idItemFamilia: number;
    idItemLinha: number;
    idItemMarca: number;
    idsUnidadesNegocios: number[] = [];
    idsItensTipos: number[] = [];
    itemTipoNull = false;
    idsNaturezasVendas: number[] = [];
    naturezaVendaNull = false;
    idsClassificacoes: number[] = [];
    classificacaoNull = false;
    idsMercados: number[] = [];
    mercadoNull = false;
    idLinhaProducao: number;
    ignorarRepresentante: boolean;

    idRepresentante: number;
    representante: Representante;


    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }
        // Código Integração ERP
        if (this.codigoIntegracaoErp) {
            params = params.append('codigoIntegracaoErp', this.codigoIntegracaoErp);
        }
        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }
        // Pessoa
        if (this.idPessoa) {
            params = params.append('idPessoa', this.idPessoa.toString());
        }
        // Item Grupo
        if (this.idItemGrupo) {
            params = params.append('idItemGrupo', this.idItemGrupo.toString());
        }
        // Item Sub Grupo
        if (this.idItemSubgrupo) {
            params = params.append('idItemSubgrupo', this.idItemSubgrupo.toString());
        }
        // Item Familia
        if (this.idItemFamilia) {
            params = params.append('idItemFamilia', this.idItemFamilia.toString());
        }
        // Item Linha
        if (this.idItemLinha) {
            params = params.append('idItemLinha', this.idItemLinha.toString());
        }
        // Item Marca
        if (this.idItemMarca) {
            params = params.append('idItemMarca', this.idItemMarca.toString());
        }

        // Unidades de Negócios
        this.idsUnidadesNegocios?.forEach(idUnidadeNegocio => {
            params = params.append('idUnidadeNegocio', idUnidadeNegocio.toString());
        });

        // Itens Tipos
        this.idsItensTipos?.forEach(idItemTipo => {
            if (idItemTipo > 0) {
                params = params.append('idItemTipo', idItemTipo.toString());
            }
        });
        // Item Tipo Nulo
        if (this.itemTipoNull) {
            params = params.append('itemTipoNull', 'true');
        }

        // Naturezas de Vendas
        this.idsNaturezasVendas?.forEach(idNaturezaVenda => {
            if (idNaturezaVenda > 0) {
                params = params.append('idNaturezaVenda', idNaturezaVenda.toString());
            }
        });
        // Natureza de Venda Nula
        if (this.naturezaVendaNull) {
            params = params.append('naturezaVendaNull', 'true');
        }

        // Mercados
        this.idsMercados?.forEach(idMercado => {
            if (idMercado > 0) {
                params = params.append('idMercado', idMercado.toString());
            }
        });
        // Mercado Nulo
        if (this.mercadoNull) {
            params = params.append('mercadoNull', 'true');
        }

        // Linha de Produção
        if (this.idLinhaProducao) {
            params = params.append('idLinhaProducao', this.idLinhaProducao.toString());
        }

        // Classificações de itens
        this.idsClassificacoes?.forEach(idClassificacao => {
            if (idClassificacao > 0) {
                params = params.append('idClassificacao', idClassificacao.toString());
            }
        });
        // Sem classificação
        if (this.classificacaoNull) {
            params = params.append('classificacaoNull', 'true');
        }

        // Ignorar representante e seu atendente e gerente
        if (this.ignorarRepresentante) {
            params = params.append('ignorarRepresentante', this.ignorarRepresentante.toString());
        }
        // Representante
        if (this.idRepresentante) {
            params = params.append('idRepresentante', this.idRepresentante.toString());
        }

        return params;
    }

    clear() {
        this.filterPsq = null;
        this.codigoIntegracaoErp = null;
        this.situacao = null;
        this.idPessoa = null;
        this.pessoa = null;
        this.idItemGrupo = null;
        this.idItemSubgrupo = null;
        this.idItemFamilia = null;
        this.idItemLinha = null;
        this.idItemMarca = null;
        this.idsClassificacoes = [];
        this.classificacaoNull = false;
        this.idsUnidadesNegocios = [];
        this.idsItensTipos = [];
        this.itemTipoNull = false;
        this.idsNaturezasVendas = [];
        this.naturezaVendaNull = false;
        this.idsMercados = [];
        this.mercadoNull = false;
        this.idLinhaProducao = null;


        this.ignorarRepresentante = null;
        this.idRepresentante = null;
        this.representante = null;
    }
}

